import React from 'react'

import { Col, Row } from 'antd'

import '../asset/less/ImageDisplay.css'

const ImageDisplay = (props) => {
  //supports only 3 columns for now
  // props: imageArray: array of images

  //rows: array of N elements, where N is the number of rows needed to display all images
  const rows = [...Array(Math.ceil(props.imageArray.length / 3))]
  // chunk the products into the array of rows
  const displayRows = rows.map((row, idx) => props.imageArray.slice(idx * 3, idx * 3 + 3))
  // map the rows as div.row
  const content = displayRows.map((row, index) => (
    <Row key={index} gutter={[16, 16]}>
      {row.map((image) => (
        <Col key={image.src} span={8}>
          <img className='displayImg' src={image.src} />
          <div>{image.caption}</div>
          <p />
        </Col>
      ))}
    </Row>
  ))
  return <div>{content}</div>
}

export default ImageDisplay
